import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('@/page/index.vue')
const selfDesign = () => import('@/page/selfDesign/selfDesign.vue')
// const sdPhase1 = () => import('@/page/selfDesign/sdPhase1/sdPhase1.vue')
// const sdPhase2 = () => import('@/page/selfDesign/sdPhase2/sdPhase2.vue')
// const sdPhase3 = () => import('@/page/selfDesign/sdPhase3/sdPhase3.vue')
// const saveUserData = () => import('@/page/selfDesign/saveUserData/saveUserData.vue')
// const sdPhase4 = () => import('@/page/selfDesign/sdPhase4/sdPhase4.vue')
// const massing = () => import('@/page/selfDesign/massing/massing.vue')
// const orderMessage = () => import('@/page/selfDesign/orderMessage/orderMessage.vue')
// const sdPhase5 = () => import('@/page/selfDesign/sdPhase5/sdPhase5.vue')
const material = () => import('@/page/material/material.vue')
const cart = () => import('@/page/cart/cart.vue')
const orderManagement = () => import('@/page/orderManagement/orderManagement.vue')
const order = () => import('@/page/orderManagement/order/order.vue')
const myClient = () => import('@/page/myClient/myClient.vue')
const fabrics = () => import('@/page/fabrics/fabrics.vue')
const fashion=()=>import('@/page/fashion/fashion.vue')
const balance = () => import('@/page/orderManagement/balance/balance.vue')
const openingInvoice = () => import('@/page/orderManagement/myInvoice/openingInvoice/openingInvoice.vue')
const invoiceQualifications = () => import('@/page/orderManagement/myInvoice/invoiceQualifications/invoiceQualifications.vue')
const shippingAddress = () => import('@/page/orderManagement/myInvoice/shippingAddress/shippingAddress.vue')
const delivery = () => import('@/page/orderManagement/delivery/delivery.vue')
const applyDelivery = () => import('@/page/orderManagement/order/applyDelivery.vue')
const applySuccess = () => import('@/page/orderManagement/order/applySuccess.vue')
const zfbSuccess = () => import('@/page/paySuccess/zfbSuccess.vue')
const quickOrder = () => import('@/page/quickOrder/quickOrder.vue')
const micro = () => import('@/page/microCustomization/micro.vue')
const microCustomization = () => import('@/page/microCustomization/index/index.vue')
const microList = () => import('@/page/microCustomization/list/list.vue')
const microDetail = () => import('@/page/microCustomization/detail/detail.vue')
const microOrderMessage = () => import('@/page/microCustomization/orderMessage/orderMessage.vue')
const microSaveUserData = () => import('@/page/microCustomization/saveUserData/saveUserData.vue')
const microSdPhase4 = () => import('@/page/microCustomization/sdPhase4/sdPhase4.vue')
const microMassing = () => import('@/page/microCustomization/massing/massing.vue')
const showAll = () => import('@/page/microCustomization/showAll/showAll.vue')
const aboutUs = () => import('@/page/aboutUs/aboutUs.vue');
const account = () => import('@/page/account/account.vue');

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '专属私人定制',
      component: Index,
      meta: {
        title: "专属私人定制"
      }
    },
    {
      path: '/material',
      name: '物资物料',
      component: material,
    },
    {
      path: '/orderManagement',
      name: '订单管理',
      component: orderManagement,
      redirect: '/orderManagement/order',
      children: [
        { path: 'order', name: '我的订单', component: order },
        { path: 'delivery', name: '发货查询', component: delivery },
        { path: 'balance', name: '现金管理', component: balance },
        { path: 'openingInvoice', name: '发票管理', component: openingInvoice },
        { path: 'invoiceQualifications', name: '增票资质', component: invoiceQualifications },
        { path: 'shippingAddress', name: '收货地址', component: shippingAddress },
        { path: 'applyDelivery', name: '批量发货', component: applyDelivery },
        { path: 'applySuccess', name: 'applySuccess', component: applySuccess },
      ]
    },
    {
      path: '/cart',
      name: '购物车',
      component: cart,
    },
    {
      path: '/myClient',
      name: '我的客户',
      component: myClient,
    },
    {
      path: '/fabrics',
      name: '面料信息',
      component: fabrics,
    },
    {
      path: '/fashion',
      name: '款式信息',
      component: fashion,
    },
    {
      path: '/quickorder',
      name: '快速下单',
      component: quickOrder,
    },
    {
      path: '/selfdesign',
      name: '自主设计',
      component: selfDesign,
      // redirect: '/selfdesign',
      // children: [
      //   { path: 'sdphase1', name: 'sdphase1', component: sdPhase1 },
      //   { path: 'sdphase2', name: 'sdphase2', component: sdPhase2 },
      //   { path: 'sdphase3', name: 'sdphase3', component: sdPhase3 },
      //   { path: 'saveUserData', name: 'saveUserData', component: saveUserData },
      //   { path: 'sdPhase4', name: 'sdPhase4', component: sdPhase4 },
      //   { path: 'massing', name: 'massing', component: massing },
      //   { path: 'orderMessage', name: 'orderMessage', component: orderMessage },
      //   { path: 'sdPhase5', name: 'sdPhase5', component: sdPhase5 },
      // ]
    },
    {
      path: '/micro',
      name: 'micro',
      component: micro,
      redirect: '/micro/microCustomization',
      children: [
        { path: 'microCustomization', name: '微定制', component: microCustomization },
        { path: 'microList', name: 'microList', component: microList },
        { path: 'microDetail', name: 'microDetail', component: microDetail },
        { path: 'microOrderMessage', name: 'microOrderMessage', component: microOrderMessage },
        { path: 'microSaveUserData', name: '量体', component: microSaveUserData },
        { path: 'microSdPhase4', name: 'microSdPhase4', component: microSdPhase4 },
        { path: 'microMassing', name: 'microMassing', component: microMassing },
      ]
    },
    {
      path: '/showAll',
      name: 'showAll',
      component: showAll,
    },
    {
      path: '/zfbSuccess',
      name: 'zfbSuccess',
      component: zfbSuccess,
    },
    {
      path: '/aboutUs',
      name: "关于我们",
      component: aboutUs,
    },
    {
      path: '/account',
      name: "account",
      component: account,
    },
    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js